import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@/../environments/environment';
import { TipoDocumento, TipoDocumentoRequest } from '@/models';

export interface DeleteTipoDocumentoError {
  message: string;
  editalNome?: string;
}

@Injectable({
  providedIn: 'root',
})
export class TipoDocumentoService {
  private baseUrl = `${environment.apiUrl}/admin/tipos-documentos`;

  constructor(private http: HttpClient) {}

  getTiposDocumentos(): Observable<TipoDocumento[]> {
    return this.http.get<TipoDocumento[]>(this.baseUrl);
  }

  getTipoDocumento(id: number): Observable<TipoDocumento> {
    return this.http.get<TipoDocumento>(`${this.baseUrl}/${id}`);
  }

  createTipoDocumento(data: TipoDocumentoRequest): Observable<TipoDocumento> {
    return this.http.post<TipoDocumento>(this.baseUrl, data);
  }

  updateTipoDocumento(id: number, data: TipoDocumentoRequest): Observable<TipoDocumento> {
    return this.http.put<TipoDocumento>(`${this.baseUrl}/${id}`, data);
  }

  deleteTipoDocumento(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`).pipe(
      catchError((error: HttpErrorResponse) => {
        // Se o erro contém informações sobre o edital vinculado
        if (error.error && error.error.editalNome) {
          const customError: DeleteTipoDocumentoError = {
            message: error.error.message || 'Não é possível excluir este tipo de documento pois está vinculado a um edital',
            editalNome: error.error.editalNome,
          };
          return throwError(() => customError);
        }
        return throwError(() => error);
      })
    );
  }

  toggleStatus(id: number, active: boolean): Observable<TipoDocumento> {
    return this.http.patch<TipoDocumento>(`${this.baseUrl}/${id}/toggle-status`, { active });
  }
}
